import React from "react";
import { Briefcase, Mail } from "lucide-react";
import { Button } from "../components/ui/button";
import { COMPANY } from "../lib/data";

export default function Career() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
      <Briefcase className="h-12 w-12 text-primary mx-auto" />
      <h1 className="font-serif text-4xl sm:text-5xl mt-6">Build a career in finance with us.</h1>
      <p className="text-muted-foreground mt-5 max-w-2xl mx-auto leading-relaxed">
        Information about open positions, internships and the way we hire will be updated here soon. In the meantime, if you're a passionate finance professional who believes in client-first values — we'd love to hear from you.
      </p>
      <a href={`mailto:${COMPANY.email}?subject=Career%20opportunity%20at%20Arthniti`} className="inline-block mt-8" data-testid="career-email-btn">
        <Button size="lg" className="bg-primary text-primary-foreground hover:brightness-110"><Mail className="h-4 w-4 mr-2" /> Write to us</Button>
      </a>
    </div>
  );
}
